var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{staticClass:"back-home",attrs:{"to":{ path: '/' }}},[_c('i',{staticClass:"el-icon-s-home"}),_vm._v(" 首页")]),_vm._v(" "),_c('el-breadcrumb-item',{staticClass:"detail-name"},[_vm._v(_vm._s(_vm.title))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f984c77","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb/index.vue
// module id = null
// module chunks = 